const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

export interface GoogleUser {
  id: string;
  email: string;
  name: string;
  picture: string;
  token: string; // Added to store the raw ID token
}

export class GoogleAuthService {
  constructor() {
    if (!GOOGLE_CLIENT_ID) {
      console.error('REACT_APP_GOOGLE_CLIENT_ID is not defined');
    }
  }

  async verifyToken(token: string): Promise<GoogleUser> {
    try {
      // For client-side, we'll decode the JWT token manually
      // The actual verification will be done on the server side
      const payload = this.decodeJWT(token);
      
      return {
        id: payload.sub,
        email: payload.email || '',
        name: payload.name || '',
        picture: payload.picture || '',
        token: token, // Store the raw ID token
      };
    } catch (error) {
      console.error('Error decoding Google token:', error);
      throw new Error('Failed to decode Google token');
    }
  }

  private decodeJWT(token: string): any {
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      );
      return JSON.parse(jsonPayload);
    } catch (error) {
      throw new Error('Invalid JWT token');
    }
  }

  renderGoogleButton(elementId: string, onSuccess: (user: GoogleUser) => void): void {
    if (!window.google) {
      throw new Error('Google API not loaded');
    }

    window.google.accounts.id.initialize({
      client_id: GOOGLE_CLIENT_ID,
      callback: async (response: any) => {
        try {
          const user = await this.verifyToken(response.credential);
          onSuccess(user);
        } catch (error) {
          console.error('Google auth error:', error);
        }
      },
    });

    window.google.accounts.id.renderButton(
      document.getElementById(elementId)!,
      {
        theme: 'outline',
        size: 'large',
        text: 'signin_with',
        locale: 'ru', // Default locale, can be dynamic
      }
    );
  }
}

declare global {
  interface Window {
    google: any;
  }
}

export const googleAuthService = new GoogleAuthService();